<template>
  <div :class="{
    'components-desktop-v255-modelCart': true,
    cp: true,
  }" :oncontextmenu="type == 3 ? 'window.event.returnValue=false' : ''">
    <el-card :shadow="shadowStr" :body-style="{
      padding: '0'
    }" class="card">
      <el-skeleton :loading="loading">
        <template slot="template">
          <div style="padding: 12px 12px 25px;box-sizing: border-box">
            <div style="position: relative">
              <el-skeleton-item variant="rect" style="width: 100%; height: 100%;position: absolute;left: 0;top: 0" />
              <!-- position: absolute;left: 0;top: 0 -->
              <img style="width: 100%;height: auto;display:block"
                src="https://static.daspatial.com/static/img/cart_bg.png" alt="" />
            </div>

            <div style="padding-top: 16px">
              <div style="text-align: left">
                <el-skeleton-item variant="text" style="width: 30%;height: 20px" />
                <span style="float:right;display:flex;align-items: center">
                  <img style="width: 16px;margin: 0 4px 0 0" src="https://static.daspatial.com/static/img/v3.7.0/liulan.svg" alt />
                  <el-skeleton-item variant="text" style="width: 16px;height: 18px" />
                  <img style="width: 16px;margin: 0 4px 0 24px" src="https://static.daspatial.com/static/img/v3.7.0/dianzhan.svg"
                    alt />
                  <el-skeleton-item variant="text" style="width: 16px;height: 18px" />
                </span>
              </div>
              <div style="margin-top: 8px;display:flex;align-items: center">
                <el-skeleton-item variant="circle" style="width: 24px;height: 24px" />
                <el-skeleton-item variant="text" style="width: 40px;height: 18px;margin-left: 10px" />
              </div>
            </div>
          </div>
        </template>
        <div style="padding: 12px 12px 25px" @mouseover="rowHide = data.dataSetId" @mouseleave="rowHide = 0">
          <div @click="
            showDetail(data);
          " style="overflow: hidden;height: auto;position: relative;border-radius: 4px;">
            <el-image style="width: 100%;height:100%;display:block;z-index: 0"
              src="https://static.daspatial.com/static/img/cart_bg.png" fit="cover"></el-image>
            <div class="box_img">
              <img v-if="data.cover" :src="data.cover + imgtail" alt
                style="display: block;width: 101%; height: 100%;object-fit: cover" />
              <el-image style="display: block;width: 100%; height: 100%"
                src="https://static.daspatial.com/static/img/defaultM.png" fit="cover" v-else></el-image>
            </div>
            <div class="rowHidden" :style="{
              opacity: rowHide == data.dataSetId ? '1' : '0',
              transition:
                rowHide == data.dataSetId ? 'opacity 0.4s ease-in-out' : ''
            }">
              <div :title="data.description" :style="{ webkitLineClamp: rowHeight }">
                {{ data.description || "暂无描述" }}
              </div>
            </div>
          </div>

          <div class="list_b" @mouseover="rowHide = data.dataSetId" @mouseleave="rowHide = 0">
            <div class="centerBox">
              <div @click="showDetail(data)" class="viewTimeStyle centetBox" style="justify-content: space-between">
                <!-- <template v-if="textMinwidth" > -->

                <div v-if="data.name.length < 10 && type !== 3" class="textEllipsis2">
                  {{ data.name }}
                </div>
                <el-tooltip v-else-if="data.name.length < 10 && type == 3" effect="dark"
                  popper-class="cardTip modelCart_cardTip2" :content="data.name" placement="bottom-start">
                  <div class="textEllipsis2">
                    {{ data.name }}
                  </div>
                </el-tooltip>
                <!-- </template> -->

                <el-tooltip v-else effect="dark" popper-class="cardTip" :content="data.name" placement="bottom-start">
                  <div class="textEllipsis">{{ data.name }}</div>
                </el-tooltip>
                <div class="centetBox numStyle" style="justify-content: flex-end">
                  <!-- <img
                style="width: 16px;margin: 0 4px 0 0"
                src="https://static.daspatial.com/static/img/model/1.svg"
                alt
              /> -->
                  <img style="width: 16px;margin: 0 4px 0 0" src="https://static.daspatial.com/static/img/v3.7.0/liulan.svg" alt />
                  <span>{{ data.viewTimes | num }}</span>
                  <!-- <img
                style="width: 16px;margin: 0 4px 0 16px"
                src="https://static.daspatial.com/static/img/model/34.svg"
                alt
              />
              <span>{{ data.commentNum | num }}</span> -->
                  <!-- <img
                style="width: 16px;margin: 0 4px 0 16px"
                src="https://static.daspatial.com/static/img/model/2.svg"
                alt
              /> -->
                  <img style="width: 16px;margin: 0 4px 0 24px" src="https://static.daspatial.com/static/img/v3.7.0/dianzhan.svg"
                    alt />
                  <span>{{ data.likeNum | num }}</span>
                </div>
              </div>
            </div>
            <div class="centetBox" @click="$emit('userInfo', data.userId)">
              <el-avatar v-if="isbgavatar(data.avatar) == -1" style="width: 24px;height: 24px;border-radius: 50%"
                :src="data.avatar"></el-avatar>
              <!-- <div
            class="bgAvatar"
            v-else
            :style="{ background: colorList[parseInt(data.userId) % 12] }"
          >
            {{ nameSay(data.nickname) }}
          </div> -->

              <img v-else class="tu" src="https://static.daspatial.com/static/img/userInfo/avatar-48.png" alt="" />

              <span class="t1" :title="data.nickname">{{ data.nickname }}</span>
              <template v-if="data.memberLevel">
                <img class="tu2" v-if="data.memberLevel == 1" src="https://static.daspatial.com/static/img/v2.8.0/mini-1.svg"
                  alt="" />
                <img class="tu2" v-if="data.memberLevel == 2" src="https://static.daspatial.com/static/img/v2.8.0/mini-2.svg"
                  alt="" />
                <img class="tu2" v-if="data.memberLevel == 4" src="https://static.daspatial.com/static/img/v2.8.0/mini-3.svg"
                  alt="" />
                <img class="tu2" v-if="data.memberLevel == 3" src="https://static.daspatial.com/static/img/v2.8.0/mini-4.svg"
                  alt="" />
              </template>
            </div>
          </div>
        </div>
      </el-skeleton>
    </el-card>

  </div>
</template>
<script>


export default {
  components: {

  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    type: {
      type: Number,
      default: 1
    },
    data: {
      type: Object,
      default: {
        dataSetId: 1
      }
    },
    shadowStr: {
      type: String,
      default: "always"
    }
    // rowHeight: Number
  },
  name: "components-desktop-v255-modelCart",
  created() { },
  data() {
    return {

      orderData: { data: null },
      imgtail: "?imageView2/1/w/600/h/400/q/70",
      rowHeight: 10,
      rowHide: 0,
    };
  },
  mounted() {
  },
  methods: {
    isbgavatar(src) {
      if (!src) return -1;
      return src.indexOf("avatar.jpg");
    },
    //模型详情
    showDetail(item) {
      if (item.viewPermission == "PRIVATE") return (this.orderData.data = {});
      this.id = item.dataSetId;
      let href = `https://www.get3d.cn/square?dataSetId=${item.dataSetId}`
      window.open(href);
    },
  },
  filters: {
    num(n) {
      if (!n) return "0";
      let arr = [];
      if (n > 999 && n < 10000) {
        n = n / 1000;
        if (n % 1 == 0) {
          return n + ".0k";
        }
        arr = n.toString().split(".");

        return arr[0] + "." + arr[1].slice(0, 1) + "k";
      } else if (n > 9999 && n < 100000) {
        n = n / 10000;
        if (n % 1 == 0) {
          return n + ".0w";
        }
        arr = n.toString().split(".");
        return arr[0] + "." + arr[1].slice(0, 1) + "w";
      } else return n;
    }
  },
  destroyed() {
    // window.onresize = null;
  }
};
</script>
<style lang="scss">
.cardTip .popper__arrow {
  display: none !important;
}

.cardTip {
  margin: 5px 0 0 50px !important;
}

.v255_hd_el_popover2 {
  width: auto !important;
  min-width: auto !important;
  max-width: 273px !important;
  padding: 8px 12px !important;
  margin-top: 4px !important;
  // margin-right: -8px !important;
  box-shadow: 0px 2px 16px 1px rgba(0, 0, 0, 0.16) !important;
  border-radius: 4px !important;
  font-size: 12px !important;

  >div {
    color: #333333 !important;
    font-weight: 600;
    // font-family: font3;
  }

  .popper__arrow {
    display: none !important;
  }
}

/* .modelCart_cardTip2 {
  margin: 5px 0 0 20px !important;
} */
</style>

<style scoped lang="scss">
.components-desktop-v255-modelCart {

  /deep/ .is-never-shadow,
  /deep/ .is-always-shadow {
    box-shadow: none;
    transform: translateY(0);
    transition: all 0.4s ease-in-out;
  }

  /deep/ .is-always-shadow:hover {
    transform: translateY(-12px);
    background: #ffffff;
    box-shadow: 0px 4px 16px 0px #dae3f3 !important;
  }

  /deep/ .is-never-shadow:hover {
    transform: translateY(-12px);
    background: #ffffff;
  }

  .card {
    overflow: hidden;
    position: relative;
    list-style: none;
    width: calc(100% - 20px);
    margin: 0 10px;
    box-sizing: border-box;
    // padding: 12px 12px 25px;
    display: inline-block;
    background: transparent;
    // animation: dropdown 0.5s ease 0s 1 both;
    // animation-delay: 0.2s;
    border-radius: 4px;
    border: 0;
    cursor: pointer;

    .el-image {
      // height: 250px !important;
      position: relative;
      display: block;
      // cursor: pointer;

      img {
        object-fit: cover;
      }
    }

    .staricon {
      position: absolute;
      left: 12px;
      top: 12px;
      z-index: 1;

      >img {
        display: block;
        width: 16px;
        height: 16px;
      }
    }

    .buttom {
      // height: 64px;
      font-size: 12px;
      font-weight: 400;
      // display: flex;
      // line-height: 48px;
      // padding: 10px 16px 8px 16px;
      padding: 16px 24px 16px 16px;
      box-sizing: border-box;
      background: #f8f8f8;

      span:first-child {
        // display: inline-block;
      }

      div {
        // line-height: 48px;
        // width: 100px;
        // display: inline-block;
      }

      .rightimg {
        display: inline-block;
        text-align: right;
        float: right;
        // width: 100px;
        // padding-right: 12px;
        // line-height: 48px;
        font-weight: 400;
        height: 20px;
        line-height: 20px;
        color: #666666;
        font-size: 12px;

        span img {
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
}

.onlylist {
  .card {
    width: 100% !important;
    margin: 0 !important;
  }
}

.statusIcon {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 3;

  .box {
    padding: 2px 8px;
    border-radius: 17px;
    // height: 20px;
    color: #ffffff;
    font-size: 14px;

    // font-family: font3;
    span {
      line-height: 20px;
    }

    img {
      margin-left: 2px;
    }
  }
}

.box_img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.rowHidden {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: linear-gradient(360deg, #081123 0%, rgba(8, 17, 35, 0.4) 100%);
  padding: 10px;
  box-sizing: border-box;
}

.rowHidden>div {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 10px;
  overflow: hidden;
  display: -webkit-box;
  text-align: left;
  line-height: 14px;
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.PrintClass {
  position: absolute;
  right: 11px;
  top: 11px;
  z-index: 3;
}

.popoverimg {
  min-width: 60px !important;
  padding: 5px;
  border-radius: 2px;
  text-align: center;
}

.staricon {
  position: absolute;
  left: 12px;
  top: 12px;
  z-index: 1;

  >img {
    display: block;
    width: 16px;
    height: 16px;
  }
}

.list_b {
  padding-top: 16px;
  // padding: 15px;
  font-size: 12px;
  font-weight: normal;
}

.list_b>div:nth-child(1) {
  justify-content: space-between;
}

.list_b>div:nth-child(2) {
  margin-top: 8px;

  .t1 {
    // max-width: calc(100% - 68px);
    max-width: 120px;
    font-weight: 700;
    // font-family: font3;
    color: #333333;
    height: 17px;
    line-height: 18px;
    margin-left: 8px;
    overflow: hidden;
    // white-space: nowrap;
    white-space: pre;
    text-overflow: ellipsis;
  }

  .tu {
    display: block;
    width: 24px;
    height: 24px;
    object-fit: cover;
    border-radius: 50%;
  }

  .tu2 {
    width: 12px;
    height: 12px;
    object-fit: cover;
    margin-left: 4px;
  }
}

.list_b_t {
  height: 20px;
  color: #858585;
}

.centetBox {
  display: flex;
  align-items: center;
}

.viewTimeStyle {
  // width: calc(100% - 20px);
  width: 100%;
  // flex: 1;
  display: flex;
  // padding-left: 8px;
  height: 20px;
  color: #858585;
  box-sizing: border-box;
}

.textEllipsis {
  flex: 1;
  // width: 165px;
  display: inline-block;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 700;
  // font-family: font3;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  padding-right: 24px;
  color: #333333;
}

.textEllipsis2 {
  flex: 1;
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  height: 22px;
  line-height: 22px;
  color: #333333;
  text-align: left;
  padding-right: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cp {
  cursor: pointer;
}

.numStyle {
  max-width: 191px;
}

.numStyle span {
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  color: #929394;
}
</style>



// WEBPACK FOOTER //
// src/components/modelCart.vue